import { Injectable } from '@angular/core';
import { UserListSdkService } from '@vendasta/contacts';
import { UserListItemInterface } from '@vendasta/contacts/lib/_internal/interfaces';
import { LoadRequest, TableDataService } from '@vendasta/va-filter2-table';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerService } from '../../core/partner.service';
import { UserList } from './user-list';

@Injectable({ providedIn: 'root' })
export class UserListsOverviewService implements TableDataService<UserList> {
  private totalResults$$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public readonly totalResults$: Observable<number> = this.totalResults$$.asObservable();
  private partnerId: string;
  private cursors: { [id: number]: string } = { 0: '' };

  constructor(private partnerService: PartnerService, private userListSdkService: UserListSdkService) {
    this.partnerId = partnerService.partnerId;
  }

  load(request: LoadRequest): Observable<UserList[]> {
    const tableValues: UserList[] = [];
    return this.userListSdkService
      .listUserLists(this.partnerId, this.cursors[request.pageIndex], request.pageSize)
      .pipe(
        map((resp) => {
          if (resp.pagingMetadata.hasMore) {
            this.cursors[request.pageIndex + 1] = resp.pagingMetadata.nextCursor;
          }
          this.totalResults$$.next(resp.pagingMetadata.totalResults);
          if (!resp || !resp.userLists) {
            return [];
          }
          for (const r of resp.userLists) {
            tableValues.push(this.convertToUserListsOverview(r));
          }
          return tableValues;
        }),
      );
  }

  convertToUserListsOverview(userListItem: UserListItemInterface): UserList {
    return {
      listId: userListItem.listId,
      userListName: userListItem.listName,
      numUsers: userListItem.itemCount ? userListItem.itemCount : 0,
      lastModified: userListItem.updated,
    };
  }
}
